import React, { ReactNode } from "react"
import Components from ".."
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import { LinkBlokProps } from "../link"

import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroContent,
  StyledHeroBreadcrumbs,
  StyledHeroDescription,
  StyledHeroButtons,
  StyledHeroImage,
  StyledHeroLogo,
  StyledProgramLogoWrapper,
  StyledProgramLogo,
} from "./partials"
import MediaCmp from "../s22_media/Media"
import Link from "../global-header/Link"

export interface HeroProps {
  logo: blokType[]
  logoUrl: blokType[]
  breadcrumbs: LinkBlokProps[]
  program_logo: blokType[]
  title: string
  description: string
  cta_button: blokType[]
  image: blokType[]
  id: string,
  custom_id: string,
}

export const HeroCmp: React.FC<HeroProps> = ({
  logo,
  logoUrl,
  breadcrumbs,
  program_logo,
  title,
  description,
  cta_button,
  image,
  id,
  custom_id,
}) => {
return (
  <StyledHero data-name="hero" id={custom_id ? custom_id : id}>
    <StyledHeroContainer form={false} dark_form={false}>
      <StyledHeroContent>
      {logo &&
          logo.map((content: any) => (
            <StyledHeroLogo key={content._uid}>
              {logoUrl &&
                logoUrl.map((content) =>
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                  })
                )}

              <MediaCmp
                media={content.media}
                aspect_ratio={content.aspect_ratio}
                video_controls={content.video_controls}
                video_loop={content.video_loop}
                video_autoplay={content.video_autoplay}
                video_muted={content.video_muted}
                external_video={content.external_video}
                youvisit_url={content.youvisit_url}
                mobile_image={content.mobile_image}
                mobile_aspect_ratio={content.mobile_aspect_ratio}
              />
            </StyledHeroLogo>
          ))}
        {breadcrumbs && (
          <StyledHeroBreadcrumbs>
            {breadcrumbs.map((l) =>
              React.createElement(Components(l.component), {
                key: l._uid,
                blok: l,
              })
            )}
          </StyledHeroBreadcrumbs>
        )}

      {program_logo && (
        <StyledProgramLogoWrapper>
          {program_logo.map((content: any) => (
            <StyledProgramLogo hover_icon={content.hover_icon}>
              <Link
                url={content.link}
                target={content.target}
                icon={content.icon}
                hover_icon={content.hover_icon}
              />
            </StyledProgramLogo>
          ))}
        </StyledProgramLogoWrapper>
      )}

        {title && <h1>{title}</h1>}
        {description && (
          <StyledHeroDescription>
            {
              unified()
                .use(remarkParse)
                .use(remarkRehype)
                .use(rehypeReact as any, {
                  createElement: React.createElement,
                  components: remarkReactComponents,
                  Fragment: React.Fragment
                })
                .processSync(description.replace(/\n/g, "  \n"))
                .result as ReactNode
            }
          </StyledHeroDescription>
        )}
        {cta_button && cta_button.length > 0 && (
          <StyledHeroButtons>
            {cta_button.map((content) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )}
          </StyledHeroButtons>
        )}
      </StyledHeroContent>
      {image && image.length > 0 && (
        <StyledHeroImage>
          {image.map((content) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
        </StyledHeroImage>
      )}
    </StyledHeroContainer>
  </StyledHero>
)
}